module.exports = __webpack_public_path__ + "03_long_gold.1446522b.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/kanai/female/layer5/03_long_gold.png
// module id = CD6U
// module chunks = 0